module.exports = __webpack_public_path__ + "img/boy_girl.012b6179.png";